__turbopack_context__.v({
  "ButtonListBlock": "ButtonListBlock-module__490dxG__ButtonListBlock",
  "ButtonListBlock__inner": "ButtonListBlock-module__490dxG__ButtonListBlock__inner",
  "text-center": "ButtonListBlock-module__490dxG__text-center",
  "text-left": "ButtonListBlock-module__490dxG__text-left",
  "text-right": "ButtonListBlock-module__490dxG__text-right",
});
